module.exports = __webpack_public_path__ + "img/box-opened.a76a0ea3.png";